import Service from './Service'

/**
 * Users API service.
 *
 * @author Erik Galloway <egalloway@claruscare.com>
 */
export default class Users extends Service {
	/**
	 * Find a user by id.
	 *
	 * @param {Number} id
	 * @return {Promisee}
	 */
	find(id) {
		return this.request.get(`v4/users/${id}`)
	}

	setAlertPreferences(id, preferences) {
		return this.request.post(
			`v4/users/${id}/user-settings?type=alert-preferences`,
			preferences
		)
	}

	updateAlertPreferences(userId, preferenceId, preferences) {
		return this.request.put(
			`v4/users/${userId}/user-settings/${preferenceId}?type=alert-preferences`,
			preferences
		)
	}

	getAlertSettings(userId) {
		return this.request.get(
			`v4/users/${userId}/user-settings?type=alert-preferences`
		)
	}
}
